import { createContext } from 'react';
var initialContext = {
  radioGroup: undefined
};
export var RadioContext = createContext(initialContext);